<template>
  <div class="popup-wrap">
    <span class="background" @click="$emit('close')">></span>
    <article>
      <a class="exit" @click="$emit('close')">
        <span></span>
        <span></span>
      </a>
      <div class="content">
        <slot />
      </div>
    </article>
  </div>
</template>

<script>
  export default {
    props: {
      data: Object
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../../sass/core/variables.scss";

.popup-wrap {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;

    width: 100%;
    height: 100%;

    span.background {
        position: absolute;
        top: 0;
        left: 0;

        width: 100%;
        height: 100%;
        max-width: 100%;

        background: rgba(0, 0, 0, 0.7);
    }

    article {
        position: absolute;
        top: 50%; left: 50%;
        width: 90%;
        max-width: 570px;
        margin: auto;
        padding: 20px;
        transform: translate(-50%, -50%);

        text-align: center;

        box-shadow: 0 3px 14px rgba(0, 0, 0, 0.2);
        border-radius: 2px;
        background-color: white;

        @media (min-width: $medium) {
            padding: 60px 20px 40px;
        }

        .exit {
            position: absolute;
            top: 0;
            right: 0;

            width: 40px;
            height: 40px;

            border-radius: 0 2px;
            background-color: $color-2;

            cursor: pointer;

            span {
                position: absolute;
                top: 18px;
                left: 7px;

                display: inline-block;
                width: 26px;
                height: 2px;

                background: white;
                transform: rotate(45deg);
            }
            span:nth-of-type(2) {
                transform: rotate(-45deg);
            }
        }

        .content {
            display: inline-block;
            vertical-align: top;
            width: 100%;
        }
    }

     &.quote-modal {
      article {
        max-width: 770px;
        width: 100%;
        padding: 71px 64px 71px 66px;
        background-color: #ffffff;
        text-align: left;

        @media (max-width: $medium) {
          width: calc(100% - 40px);
          height: calc(100vh - 40px);
          padding: 40px 20px;
          overflow: auto;
        }

        .exit {
            position: absolute;
            top: 0;
            right: 0;

            width: 40px;
            height: 40px;

            border-radius: 0 2px;
            background-color: $color-1;

            span {
                position: absolute;
                top: 19px;
                left: 10px;

                display: inline-block;
                width: 20.5px;
                height: 2px;

                background: white;
                transform: rotate(45deg);
            }
            span:nth-of-type(2) {
                transform: rotate(-45deg);
            }
        }

        .content {
          h1 {
              margin: 0;
              padding-left: 20px;

              font-size: 30px;
              font-weight: 600;
              letter-spacing: 0.5px;
              line-height: 36px;
              text-transform: uppercase;

              color: #363636;
              border-left: 2px solid $color-1;
          }

          hr {
            margin: 43px 0 47px;
            background: #dddddd;
          }

          .form {
            .subject {
              @media (min-width: $medium) {
                width: calc(100%/2 - 10px);
                flex: 0 0 calc(100%/2 - 10px);
              }
            }

            .buttons {
              margin-top: 10px;
              align-items: center;

              .button {
                  width: 127px;
                  height: 50px;
                  margin-right: 28px;
              }

              span {
                  margin: 0;

                  font-size: 12.5px;
                  font-weight: 400;
                  line-height: 18px;
                  letter-spacing: normal;

                  text-transform: unset;

                  color: #3b3e40;
              }
            }

            .validate {
              font-size: 10px;
              color: red;
              margin-top: 5px;
            }
          }
        }
      }
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Popups/Wrapper.vue